import * as React from "react";
import { Link } from "react-router-dom";

// Components
import TopicCard from "../components/TopicCard/TopicCard";
import Container from "../components/Container/Container";
import FloatingNavigation from "../components/FloatinNavigation/FloatingNavigation";
import GuidelineCTA from "../components/GuidelineCTA/GuidelineCTA";
import Footer from "../components/Footer/Footer";

// Interfaces
import Topic from "../types/Topic.interface";

interface TopicOverviewPage {
  data: Topic[];
}

const TopicOverviewPage: React.FunctionComponent<TopicOverviewPage> = (
  props: TopicOverviewPage
) => {
  const { data } = props;

  return (
    <>
      <Container>
        <div className="w-11/12 xxl:w-full mx-auto pb-4">
          <h2 className="text-l md:text-26 text-dw-blue font-semibold">
            Welcome to Threat Check.
            <br />
            Create your Policy and have fun!
          </h2>
          <p className="mt-3 text-dw-grey-13">
            First time using this tool? Learn more about how it functions{" "}
            <Link to="/faq/usage" className="font-bold underline">
              on this page.
            </Link>
          </p>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
            {data.map((topic: Topic) => {
              return <TopicCard key={topic._id} topic={topic} />;
            })}
          </div>
          <GuidelineCTA />
        </div>
      </Container>
      <FloatingNavigation />
      <Footer />
    </>
  );
};

export default TopicOverviewPage;
